/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { useTranslation } from "react-i18next";
import { TabContext, TabPanel } from '@material-ui/lab';
import { Tab, Tabs } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import Parcel from './Parcel';
import Proposal from './Proposals';

const ParcelComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabValue = queryParams.get('tab') as string || '1';

  const handleTabChange = (event: any, newValue: string) => {
    history.push(`?tab=${newValue}`)
  };

  return (
    <React.Fragment>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
        <div style={{ width: '100%', margin: '30px' }}>
          <TabContext value={tabValue}>
            <Tabs value={tabValue} onChange={handleTabChange} textColor='primary' indicatorColor='primary'>
              <Tab value='1' label={`${t('parcels')}`} />
              <Tab value='2' label={`${t('proposals')}`} />
            </Tabs>
            <TabPanel value='1'>
              <Parcel />
            </TabPanel>
            <TabPanel value='2'>
              <Proposal />
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ParcelComponent;
